module.exports = __webpack_public_path__ + "static/media/aws_saa.32b22e4c.png";